<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <rect class="a" width="18" height="18"/>
    <path class="b"
          d="M17.345.864,13.689.021a.849.849,0,0,0-.967.489L11.035,4.447a.842.842,0,0,0,.243.984l2.13,1.744a13.029,13.029,0,0,1-6.23,6.23l-1.744-2.13a.843.843,0,0,0-.984-.243L.513,12.719a.854.854,0,0,0-.492.97l.844,3.656A.843.843,0,0,0,1.687,18,16.31,16.31,0,0,0,18,1.687.843.843,0,0,0,17.345.864Z"
          transform="translate(0.001 0.001)"/>
  </svg>
</template>

<script>
export default {
  name: "Phone"
}
</script>

<style scoped>
.icon .a {
  fill: none;
}

.icon .b {
  fill: #00a2f8;
}
</style>